export const monthOptions = [
  { label: "Jan", value: 1 },
  { label: "Feb", value: 2 },
  { label: "Mar", value: 3 },
  { label: "Apr", value: 4 },
  { label: "May", value: 5 },
  { label: "Jun", value: 6 },
  { label: "Jul", value: 7 },
  { label: "Aug", value: 8 },
  { label: "Sep", value: 9 },
  { label: "Oct", value: 10 },
  { label: "Nov", value: 11 },
  { label: "Dec", value: 12 },
];

export const yearOptions = makeYearOptions();
function makeYearOptions() {
  const currentYear = new Date().getFullYear();
  let result = [];
  for (let i = 0; i < 5; i++) {
    result.push({ label: currentYear + i, value: currentYear + i });
  }
  return result;
}

export const phoneMask = "#### ### ###";

export const GENERAL_HEADER = {
  "Content-Type": "application/json;charset=UTF-8",
};

export const SCHOOLFILE_HEADER = {
  "Content-Type": "multipart/form-data",
};

export const PAYMENTPROVIDER_HEADER = {
  "content-type": "application/x-www-form-urlencoded",
  accept: "*/*",
};
